// extracted by mini-css-extract-plugin
export var container = "_iy-0";
export var content = "_iy-3";
export var customerTitle = "_iy-4";
export var empty = "_iy-5";
export var gray = "_iy-6";
export var header = "_iy-7";
export var info = "_iy-8";
export var loading = "_iy-2";
export var loadingCard = "_iy-9";
export var oneLine = "_iy-a";
export var personName = "_iy-e";
export var pillContainer = "_iy-b";
export var selected = "_iy-1";
export var text = "_iy-c";
export var twoLines = "_iy-d";
export var unread = "_iy-f";
export var unreadIndicator = "_iy-g";